import React from "react";
import TextField from "@material-ui/core/TextField";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";

// Satıcı ilanı: binadaki gerçek kat sayısı (tek sayı).
// Redux: newAdvert.filters.katSayisi -> backend create üst seviye advert.katSayisi.
function FLKatSayisiInput(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const value = filters?.katSayisi ?? "";

  return (
    <TextField
      type="number"
      label={props.filter.title || "Kat Sayısı"}
      variant="outlined"
      margin="dense"
      fullWidth
      value={value}
      onChange={(e) =>
        props.editNewAdvertFilters(
          "katSayisi",
          e.target.value === "" ? "" : Number(e.target.value)
        )
      }
      inputProps={{ min: 0 }}
    />
  );
}

export default connect(null, { ...advertRedux.actions })(FLKatSayisiInput);
